import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import {
  postUpdateTransactionStatus,
  UpdateTransactionStatusResponse,
} from '../../../api/transaction'
import { all_routes } from '../../router/all_routes'

const OrderStatus: React.FC = () => {
  const location = useLocation()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(true)
  const [result, setResult] = useState<UpdateTransactionStatusResponse | null>(
    null,
  )
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()

  const queryParams = useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ])

  const orderId = queryParams.get('order_id') || ''
  const transactionStatus = queryParams.get('transaction_status') || ''

  useEffect(() => {
    const submit = async () => {
      if (!orderId || !transactionStatus) {
        setError(
          'Parameter tidak lengkap. Pastikan order_id dan transaction_status tersedia.',
        )
        setIsSubmitting(false)
        return
      }
      try {
        setIsSubmitting(true)
        setError(null)
        const res = await postUpdateTransactionStatus({
          order_id: orderId,
          transaction_status: transactionStatus,
        })
        setResult(res)
      } catch (e) {
        setError(
          e?.response?.data?.message ||
            e?.message ||
            'Gagal memperbarui status transaksi.',
        )
      } finally {
        setIsSubmitting(false)
      }
    }

    submit()
  }, [orderId, transactionStatus])

  return (
    <div className="content">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card text-center">
              <div className="card-body py-5">
                {isSubmitting && (
                  <>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 mb-0">Memperbarui status transaksi...</p>
                  </>
                )}

                {!isSubmitting && error && (
                  <>
                    <div className="text-danger mb-2">
                      <i
                        className="isax isax-warning-2"
                        style={{ fontSize: '3rem' }}
                      />
                    </div>
                    <h5 className="text-danger">Gagal</h5>
                    <p className="mb-1">{error}</p>
                    {orderId && (
                      <p className="text-muted mb-0">Order ID: {orderId}</p>
                    )}
                  </>
                )}

                {!isSubmitting && !error && result && (
                  <>
                    <div className="mb-3">
                      {result.order_status === 'paid' && (
                        <>
                          <i
                            className="isax isax-tick-circle text-success"
                            style={{ fontSize: '3rem' }}
                          />
                          <h5 className="mt-3">Pembayaran Berhasil</h5>
                          <p className="text-muted mb-1">
                            Order ID: {result.order_id}
                          </p>
                          <p className="mb-3 text-success fw-semibold">
                            Status: PAID
                          </p>
                          <div className="d-flex justify-content-center gap-2">
                            {/* <button
                              className="btn btn-primary"
                              onClick={() =>
                                navigate(all_routes.studentCourses)
                              }
                            >
                              Lihat Kursus Saya
                            </button> */}
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => navigate(all_routes.home)}
                            >
                              Kembali ke Beranda
                            </button>
                          </div>
                        </>
                      )}

                      {result.order_status === 'pending' && (
                        <>
                          <i
                            className="isax isax-timer-1 text-warning"
                            style={{ fontSize: '3rem' }}
                          />
                          <h5 className="mt-3">
                            Menunggu Konfirmasi Pembayaran
                          </h5>
                          <p className="text-muted mb-1">
                            Order ID: {result.order_id}
                          </p>
                          <p className="mb-3 text-warning fw-semibold">
                            Status: PENDING
                          </p>
                          <p className="mb-3">
                            Silakan tunggu beberapa saat. Jika status tidak
                            berubah, periksa riwayat pesanan Anda.
                          </p>
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                navigate(all_routes.studentOrderHistory)
                              }
                            >
                              Lihat Riwayat Pesanan
                            </button>
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => window.location.reload()}
                            >
                              Muat Ulang
                            </button>
                          </div>
                        </>
                      )}

                      {result.order_status === 'failed' && (
                        <>
                          <i
                            className="isax isax-close-circle text-danger"
                            style={{ fontSize: '3rem' }}
                          />
                          <h5 className="mt-3">Pembayaran Gagal</h5>
                          <p className="text-muted mb-1">
                            Order ID: {result.order_id}
                          </p>
                          <p className="mb-3 text-danger fw-semibold">
                            Status: FAILED
                          </p>
                          <p className="mb-3">
                            Mohon coba lagi atau gunakan metode pembayaran lain.
                          </p>
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => navigate(all_routes.home)}
                            >
                              Kembali ke Beranda
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderStatus
